<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-sidebar ref="productSidebar" :isProcurementView="isProcurementView" />

    <div class="flex justify-between">
      <p>This list shows the stock products assigned to this venue</p>
      <div class="flex justify-end">
        <!-- <vs-button icon="add" @click="onClickAssign" type="relief" color="primary" class="mr-3">Assign stock product</vs-button> -->
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="8" :data="filteredStockProducts" @selected="onClicked">
        <template slot="header">
          <div class="flex mb-2">
            <vs-select v-model="filters.category" autocomplete class="w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.category" />
            </vs-select>

            <vs-select v-model="filters.vendor" autocomplete class="ml-2 w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.vendor" />
            </vs-select>

            <vs-select v-model="filters.status" autocomplete class="ml-2 w-1/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.status" />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <!-- <vs-th sort-key="number">Number</vs-th> -->
          <vs-th>Name</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>Vendor</vs-th>
          <!-- <vs-th sort-key="unitPrice">Unit price</vs-th> -->
          <vs-th sort-key="venueAmount">Stock balance</vs-th>
          <vs-th sort-key="onTheWay">On the way</vs-th>
          <vs-th sort-key="isMandatory">Type</vs-th>
          <vs-th>Created at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data" :state="tr.isDelisted ? 'danger' : ''">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start items-center">
                    <img width="40" height="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.stockProduct.name">
                        {{ tr.stockProduct.name }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <div class="flex">
                        <div>
                          <small>{{ tr.stockProduct.number }}</small>
                        </div>
                        &nbsp;•&nbsp;
                        <vs-chip :color="tr.isDelisted ? 'danger' : ''">
                          {{ tr.isDelisted ? "Delisted " : "Listed" }}
                        </vs-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.stockProduct.productCategoryId">
                  {{ productCategories.find(e => e.productCategoryId.id === tr.stockProduct.productCategoryId).name }}
                </div>
                <div v-else>
                  <vs-chip>No category</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.stockProduct.vendorId">
                  {{
                    vendors.find(e => e.vendorId.id === tr.stockProduct.vendorId) != null
                      ? vendors.find(e => e.vendorId.id === tr.stockProduct.vendorId).name
                      : ""
                  }}
                </div>
                <div v-else>
                  <vs-chip>No vendor</vs-chip>
                </div>
              </vs-td>
              <!-- <vs-td>
                {{ tr.stockProduct.unitPrice }}
                DKK
              </vs-td> -->
              <vs-td>
                <!-- <vs-chip v-if="tr.venueAmount <= 0" color="danger">
                    {{ tr.venueAmount | numberFormatDK }}
                  </vs-chip> -->
                <vs-chip class="whitespace-no-wrap">
                  <div class="flex items-center">
                    <div>
                      {{ tr.venueAmount | formatDecimal(1) }}
                      {{ tr.stockProduct.productUnit }}
                    </div>

                    <vx-tooltip class="pt-1" :text="getStockProductExplanationString(tr.storageAmounts)" position="bottom">
                      <feather-icon icon="InfoIcon" svg-classes="h-4 w-4" class="ml-1" />
                    </vx-tooltip>
                  </div>
                </vs-chip>
              </vs-td>
              <vs-td>{{ tr.onTheWay }} {{ tr.stockProduct.productUnit }} </vs-td>
              <vs-td>
                <vs-chip :color="tr.isMandatory ? 'primary' : ''">
                  {{ tr.isMandatory ? "Mandatory " : "Optional" }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div v-if="tr.stockProduct.createdAction" class="flex">
                  <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
                  {{ tr.stockProduct.createdAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductSidebar from "./AssignedStockProductSidebar.vue";

export default {
  components: {
    HandleProductSidebar
  },
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    },
    isProcurementView: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      isLoading: true,
      ProductIcon,
      filters: {
        category: null,
        vendor: null,
        status: null
      }
    };
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        let venueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          venueId = this.$store.getters["venues/activeVenueId"];
        }

        await this.$store.dispatch("pos/assignedStockProducts/getAssignedStockProductsByVenue", venueId);
        this.isLoading = false;
      },
      immediate: true
    }
  },
  methods: {
    onClicked(item) {
      this.$refs.productSidebar.show(item.id);
    },
    async onClickAssign() {
      // this.$refs.productSidebar.showEmptyProduct();
    },

    getStockLocationStatusString(stocks) {
      return stocks
        .map(e => {
          // const location = this.pimStockLocations.locations.find(l => l.id === e.stockId.id);
          return `${parseInt(e.amount)}`;
        })
        .join(" ");
    },

    getStockProductExplanationString(stocks) {
      return stocks.map(e => `${e.storageIdentifier.name}: ${parseInt(e.amount)}`).join(" | ");
    }
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      assignedStockProducts: "pos/assignedStockProducts/assignedStockProducts",
      countries: "pos/countries/countries",
      productCategories: "pos/countrySettings/stockCategories",
      pouringCategories: "pos/countrySettings/pouringCategories",
      vendors: "pos/vendors/vendors"
    }),

    selectableFilters() {
      return {
        category: [
          { text: "Filter by category", value: null },
          ...this.productCategories.map(e => ({
            text: e.name,
            value: e.productCategoryId.id
          }))
        ],
        vendor: [
          { text: "Filter by vendor", value: null },
          ...this.vendors.map(e => ({
            text: e.name,
            value: e.vendorId.id
          }))
        ],
        status: [
          { text: "Filter by status", value: null },
          { text: "Locked", value: 1 },
          { text: "Unlocked", value: 2 }
        ]
      };
    },

    filteredStockProducts() {
      return this.assignedStockProducts
        .filter(e => {
          if (this.filters.category && e.stockProduct.productCategoryId != this.filters.category) {
            return false;
          }

          if (this.filters.vendor && e.stockProduct.vendorId != this.filters.vendor) {
            return false;
          }

          if (this.filters.status == 1 && !e.stockProduct.inactive) {
            return false;
          }

          if (this.filters.status == 2 && e.stockProduct.inactive) {
            return false;
          }

          return true;
        })
        .slice()
        .sort((a, b) => (a.stockProduct.createdAt < b.stockProduct.createdAt ? 1 : -1));
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.$store.dispatch("pos/countrySettings/getCountrySettings"), this.$store.dispatch("pos/vendors/getVendors")]);
    this.isLoading = false;
  }
};
</script>